const BASE_URL = 'http://43.205.42.216:8000'
//Auth
export const LOGIN_PHARMACY = `${BASE_URL}/pharmacy/login/`

//Common
export const UPLOAD_IMAGE = `${BASE_URL}/common/upload-file/`
// Manage Pharmacy
export const PRODUCT_LISTING = `${BASE_URL}/pharmacy/list-products/`
export const PRODUCT_TYPE_LIST = `${BASE_URL}/pharmacy/list-product-types/`
export const PHARMACY_BOOKING_LIST = `${BASE_URL}/medicine-order/`
export const PHARMACY_PRODUCT_DEATILS = `${BASE_URL}/pharmacy/list-product/products_id/`
export const APPOINTMENT_STATUS = `${BASE_URL}/doctors/list-appointment-status/`
export const LIST_PRODUCT_CATEGORY = `${BASE_URL}/pharmacy/list-product-category/`
export const PHARMACY_ADD_PRODUCT = `${BASE_URL}/pharmacy/add-product/`
export const PHARMACY_PRODUCT_SIZES = `${BASE_URL}/pharmacy/list-wearable-sizes/`
export const DRUG_COMPOSITION = `${BASE_URL}/pharmacy/list-drug-composition/`
export const PRODUCT_SUB_TYPE = `${BASE_URL}/pharmacy/list-pharmacy-product-subtypes/`
